import Box from "@mui/material/Box";
import { DataGridProps, GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import {
  StyledDataGrid,
  StyledEmptyWrapper,
  StyledPaper,
  StyledTypography,
} from "./styled";

export type Columns = GridColDef[];

interface Props<T> extends Omit<DataGridProps, "rows" | "columns"> {
  columns?: any[];
  data: T[];
  loading?: boolean;
  title?: string;
  heightTable?: string | number;
  emptyStateMessage?: string;
  actions?: React.ReactNode;
  minHeight?: string;
}

const TranslationTable = <T extends object>({
  data,
  columns,
  title,
  heightTable = "84vh",
  loading,
  emptyStateMessage = "No results",
  actions,
  minHeight,

  ...rest
}: Props<T>) => {
  const [expandedRowId, setExpandedRowId] = useState<string | number>(0);

  const getAllColumns = (data: T[]) => {
    return Object.keys(data[0]).map((field) => ({ field }));
  };

  if (!loading && !data.length) {
    return (
      <StyledPaper>
        <StyledEmptyWrapper>
          <StyledTypography>{emptyStateMessage}</StyledTypography>
        </StyledEmptyWrapper>
      </StyledPaper>
    );
  }

  return (
    <Box sx={{ width: "100%", height: heightTable, minHeight }}>
      <StyledDataGrid
        {...rest}
        columns={columns || getAllColumns(data)}
        rows={data}
        onRowClick={(row) => setExpandedRowId(row.id)}
        getRowHeight={({ id }) => {
          if (id === expandedRowId) {
            return "auto";
          }

          return null;
        }}
        disableColumnMenu
        loading={loading}
        localeText={{ noRowsLabel: emptyStateMessage }}
        disableRowSelectionOnClick
        sx={{
          "&.MuiDataGrid-root": {
            overflow: "hidden",
          },
        }}
      />
    </Box>
  );
};

export default TranslationTable;
